import "../styles/main.scss"
import "./jquery-setup"

// Vendor imports
import "lazysizes/plugins/bgset/ls.bgset"
import "lazysizes"
import "picturefill"
import "formalism"
import "./modules/polyfills"
import "@fancyapps/fancybox"
import Choices from "choices.js"

window.Choices = Choices

// Dev tools
// import "harmony/grid-tools"

// Module imports
import "./modules/svgIconSprite"
import "./modules/smallMenu"
import "./modules/largeMenu"
import "./modules/carousel"
import "./modules/accordion"
import "./modules/fancybox"
import "./modules/activityMaps"
import "./modules/forms"
import "./modules/cookieViews"
import "./modules/responsiveTables"
import "./modules/popup"

import "./vue/app"

if (import.meta.hot) import.meta.hot.accept()
